// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.solutions.practicepay.UpdatePracticePaySettingsRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdatePracticePaySettingsRequest extends GandalfModelBase {

	@GandalfLabel('Pay Online')
	@GandalfValidator({ notNull: { message: 'Pay Online is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	payOnlineEnabled!: boolean;

	@GandalfLabel('Pay Online URL')
	@GandalfValidator({ sizeString: { message: 'Pay Online URL must be between 3 and 30 characters', minLength: 3, maxLength: 30 } })
	@GandalfProperty({ designType: String })
	payOnlineUrlPath!: string | null;

	@GandalfLabel('Practice Pay Settings')
	@GandalfValidator({ notNull: { message: 'Practice Pay Settings is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	practicePaySettingsId!: number;

	@GandalfLabel('Statement Pay Online')
	@GandalfValidator({ notNull: { message: 'Statement Pay Online is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	statementPayOnlineEnabled!: boolean;

}
